import React from "react";
import "./chatbot.css";
import chatbot from "./assets/NaiRa_Blue-Outline_BAR.svg";

export function ChatbotIcon({ onClick }) {
  return (
    <button type="button" className="chatbotButton" onClick={onClick} aria-label="Open chatbot">
      <img style={{width: "90%", height: "90%"}} src={chatbot} alt="NaiRA Chatbot" />
    </button>
  );
}
